import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { createPortal } from "react-dom";

import { FilteringType } from "components/prime-data-table/interfaces";
import { getFilterOptions } from "../../helpers/getTranslatedFilterOptions";

import styles from "./Filter.module.scss";

interface IFilterDatePopupProps {
    filterDateType: FilteringType;
    handleFilterDateTypeChange: Function;
    tableRef?: any;
    inputRef?: any;
    t: Function;
}

export const FilterDateTypePopup = ({ filterDateType, handleFilterDateTypeChange, t, tableRef, inputRef }: IFilterDatePopupProps) => {
    const popUpRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLDivElement>(null);

    const [popUpPosition, setPopUpPosition] = useState<any>({ top: 0, left: 0, width: 0 });

    const [popUpOpen, setPopUpOpen] = useState<boolean>(false);

    const translatedOptions = getFilterOptions("date");

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                popUpRef.current &&
                !popUpRef.current.contains(event.target) &&
                !["p-dropdown-items", "p-dropdown-item", "p-dropdown-header", "p-dropdown-filter", "p-dropdown-filter-icon"].some(
                    (className) => (event.target.className as string).includes(className)
                ) &&
                event.target != buttonRef.current
            )
                closePopUp();
        };

        if (popUpOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            checkPopUpPosition();
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [popUpOpen]);

    const checkPopUpPosition = () => {
        if (tableRef.current) {
            const tabelWidth = tableRef.current?.offsetWidth;
            const popUpInputWidth = inputRef.current?.offsetWidth;

            const popUpPositionX = inputRef.current?.offsetLeft;
            const popUpWidth = inputRef.current?.offsetWidth > 175 ? inputRef.current?.offsetWidth : 175;

            let _popUpPosition = { left: popUpPositionX, width: popUpWidth };

            if (tabelWidth - (inputRef.current?.offsetLeft + popUpWidth + 6) <= 0) {
                _popUpPosition = { ..._popUpPosition, left: popUpPositionX + (popUpInputWidth - popUpWidth) };
            }

            setPopUpPosition(_popUpPosition);
        }
        return false;
    };

    const closePopUp = () => {
        setPopUpOpen(false);
    };

    const handleChangeFilterType = (e) => {
        const { value } = e.target;
        handleFilterDateTypeChange(value);
        closePopUp();
    };
    return (
        <>
            <span
                onClick={() => setPopUpOpen((prev) => !prev)}
                className={"pi pi-cog state-input-filter-settings-button"}
                ref={buttonRef}
            />

            {popUpOpen &&
                createPortal(
                    <div className={styles.popup} style={popUpPosition} ref={popUpRef}>
                        <Dropdown
                            className="table-filter prime-table-filter-input-font"
                            value={filterDateType}
                            options={translatedOptions}
                            onChange={handleChangeFilterType}
                            optionLabel="label"
                            optionValue="value"
                            placeholder={`${t("Filter Type")}`}
                            name="filterDataType"
                        />
                    </div>,
                    tableRef.current
                )}
        </>
    );
};
